export class HeaderMobile {
  private headerMobile: HTMLElement | null;
  private menuButton: HTMLElement | null;
  private mobileNav: HTMLElement | null;
  private menuBurger: HTMLElement | null;
  private submenus: NodeListOf<HTMLElement>;
  private backButtons: NodeListOf<HTMLElement>;
  private submenuTriggers: NodeListOf<HTMLElement>;

  constructor() {
    this.headerMobile = document.querySelector('.header-mobile');
    this.menuButton = document.querySelector('.header-mobile__menu');
    this.mobileNav = document.querySelector('.header-mobile__nav');
    this.menuBurger = document.querySelector('.header-mobile__menu-burger');
    this.submenus = document.querySelectorAll('.header-mobile__nav-submenu');
    this.backButtons = document.querySelectorAll('.header-mobile__nav-submenu-back');
    this.submenuTriggers = document.querySelectorAll('.header-mobile__nav-link[data-submenu]');

    this.init();
  }

  private init(): void {
    this.handleMenu();
    this.handleSubmenus();
    this.handleBackButtons();
  }

  private handleMenu(): void {
    if (!this.menuButton || !this.mobileNav) return;

    this.menuButton.addEventListener('click', () => {
      if (this.mobileNav?.classList.contains('active')) {
        this.closeMenu();
      } else {
        this.openMenu();
      }
    });
  }

  private openMenu(): void {
    this.headerMobile?.classList.add('menu-open');
    this.menuButton?.classList.add('active');
    this.menuBurger?.classList.add('active');
    this.mobileNav?.classList.add('active');
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
  }

  private closeMenu(): void {
    this.headerMobile?.classList.remove('menu-open');
    this.menuButton?.classList.remove('active');
    this.menuBurger?.classList.remove('active');
    this.mobileNav?.classList.remove('active');
    this.closeAllSubmenus();
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.width = '';
  }

  private handleSubmenus(): void {
    this.submenuTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        const submenuId = trigger.getAttribute('data-submenu');
        if (!submenuId) return;

        const submenu = this.mobileNav?.querySelector(
          `.header-mobile__nav-submenu[data-submenu="${submenuId}"]`
        );
        if (submenu) {
          submenu.classList.add('active');
        }
      });
    });
  }

  private handleBackButtons(): void {
    this.backButtons.forEach(button => {
      button.addEventListener('click', () => {
        const submenu = button.closest('.header-mobile__nav-submenu');
        submenu?.classList.remove('active');
      });
    });
  }

  private closeAllSubmenus(): void {
    this.submenus.forEach(submenu => {
      submenu.classList.remove('active');
    });
  }
}
